import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctContractDemandStatus, TsrctDemandProcessStatus } from '@/generated/gql/graphql';
import { ContractDemandStatusChip } from '~/components/ContractDemandStatusChip/ContractDemandStatusChip';

export type DemandProcessStatusChipCellValue = Union.Nullable<keyof typeof TsrctDemandProcessStatus>;

interface ContractDemandStatusChipCellProps<R extends GridValidRowModel = any> {
  value: TsrctContractDemandStatus;
  row: R;
}

export const ContractDemandStatusChipCell = <R extends GridValidRowModel = any>({
  value,
}: ContractDemandStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div>
      <ContractDemandStatusChip status={value} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
